import { TIdToPageConfigMap } from 'models/common.model'
import { HeaderId } from 'nove8/constants/root-constants'
import { PageIdStylioHusap } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_STYLIO_HUSAP: TIdToPageConfigMap = {
  [PageIdStylioHusap.AGE_HUSAP]: {
    id: PageIdStylioHusap.AGE_HUSAP,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioHusap.SHOP_SMARTER_HUSAP]: {
    id: PageIdStylioHusap.SHOP_SMARTER_HUSAP,
    headerId: HeaderId.BACK_TITLE_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdStylioHusap.HAIR_COLOR_HUSAP]: {
    id: PageIdStylioHusap.HAIR_COLOR_HUSAP,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.WARDROBE_COLORS_HUSAP]: {
    id: PageIdStylioHusap.WARDROBE_COLORS_HUSAP,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.EYES_COLOR_HUSAP]: {
    id: PageIdStylioHusap.EYES_COLOR_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.SKIN_COLOR_HUSAP]: {
    id: PageIdStylioHusap.SKIN_COLOR_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.CLIMAT_HUSAP]: {
    id: PageIdStylioHusap.CLIMAT_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.BODY_SHAPE_HUSAP]: {
    id: PageIdStylioHusap.BODY_SHAPE_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.STYLIO_TO_HELP_HUSAP]: {
    id: PageIdStylioHusap.STYLIO_TO_HELP_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.MAIN_GOAL_HUSAP]: {
    id: PageIdStylioHusap.MAIN_GOAL_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
    progressBarHidden: true,
  },
  [PageIdStylioHusap.WHERE_TO_SHOP_HUSAP]: {
    id: PageIdStylioHusap.WHERE_TO_SHOP_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.WARDROBE_PERCENTAGE_HUSAP]: {
    id: PageIdStylioHusap.WARDROBE_PERCENTAGE_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.URGE_2_HUSAP]: {
    id: PageIdStylioHusap.URGE_2_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioHusap.URGE_3_HUSAP]: {
    id: PageIdStylioHusap.URGE_3_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioHusap.URGE_9_HUSAP]: {
    id: PageIdStylioHusap.URGE_9_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioHusap.URGE_4_HUSAP]: {
    id: PageIdStylioHusap.URGE_4_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioHusap.URGE_7_HUSAP]: {
    id: PageIdStylioHusap.URGE_7_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioHusap.URGE_8_HUSAP]: {
    id: PageIdStylioHusap.URGE_8_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioHusap.STYLE_DRAWN_TO_HUSAP]: {
    id: PageIdStylioHusap.STYLE_DRAWN_TO_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.OUTFIT_EMOTION_HUSAP]: {
    id: PageIdStylioHusap.OUTFIT_EMOTION_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.NOTHING_TO_WEAR_HUSAP]: {
    id: PageIdStylioHusap.NOTHING_TO_WEAR_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.ARCHETYPE_INTRO_HUSAP]: {
    id: PageIdStylioHusap.ARCHETYPE_INTRO_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioHusap.LOOKING_FEMININE_HUSAP]: {
    id: PageIdStylioHusap.LOOKING_FEMININE_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.STYLES_FEEL_LIKE_YOU_HUSAP]: {
    id: PageIdStylioHusap.STYLES_FEEL_LIKE_YOU_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.TALL_HUSAP]: {
    id: PageIdStylioHusap.TALL_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.WEIGHT_HUSAP]: {
    id: PageIdStylioHusap.WEIGHT_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.WARDROBE_CHANGED_HUSAP]: {
    id: PageIdStylioHusap.WARDROBE_CHANGED_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.FAVORITE_COLORS_HUSAP]: {
    id: PageIdStylioHusap.FAVORITE_COLORS_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.LIKE_OR_DISLIKE_11_HUSAP]: {
    id: PageIdStylioHusap.LIKE_OR_DISLIKE_11_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.LIKE_OR_DISLIKE_14_HUSAP]: {
    id: PageIdStylioHusap.LIKE_OR_DISLIKE_14_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.LIKE_OR_DISLIKE_15_HUSAP]: {
    id: PageIdStylioHusap.LIKE_OR_DISLIKE_15_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.LIKE_OR_DISLIKE_18_HUSAP]: {
    id: PageIdStylioHusap.LIKE_OR_DISLIKE_18_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.LIKE_OR_DISLIKE_19_HUSAP]: {
    id: PageIdStylioHusap.LIKE_OR_DISLIKE_19_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.WALK_INTO_ROOM_HUSAP]: {
    id: PageIdStylioHusap.WALK_INTO_ROOM_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.PERFECT_WEEKEND_HUSAP]: {
    id: PageIdStylioHusap.PERFECT_WEEKEND_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.LIFESTYLE_FOCUS_HUSAP]: {
    id: PageIdStylioHusap.LIFESTYLE_FOCUS_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.OUTFIT_NEEDS_HUSAP]: {
    id: PageIdStylioHusap.OUTFIT_NEEDS_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.WARDROBE_ALIGNS_HUSAP]: {
    id: PageIdStylioHusap.WARDROBE_ALIGNS_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_PROGRESS_MENU,
    progressBar: 'controlled',
  },
  [PageIdStylioHusap.PREPARE_FLOW_HUSAP]: {
    id: PageIdStylioHusap.PREPARE_FLOW_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioHusap.EMAIL_HUSAP]: {
    id: PageIdStylioHusap.EMAIL_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioHusap.EMAIL_CONSENT_HUSAP]: {
    id: PageIdStylioHusap.EMAIL_CONSENT_HUSAP,
    hasHeader: true,
    hasHeaderBackButton: true,
    headerId: HeaderId.BACK_TITLE_MENU,
  },
  [PageIdStylioHusap.SUBSCRIPTIONS_HUSAP]: {
    id: PageIdStylioHusap.SUBSCRIPTIONS_HUSAP,
  },
  [PageIdStylioHusap.CANCEL_OFFER_HUSAP]: {
    id: PageIdStylioHusap.CANCEL_OFFER_HUSAP,
  },
  [PageIdStylioHusap.AI_STYLIST_UPSELL_HUSAP]: {
    id: PageIdStylioHusap.AI_STYLIST_UPSELL_HUSAP,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioHusap.FACE_STYLING_PDF_UPSELL_HUSAP]: {
    id: PageIdStylioHusap.FACE_STYLING_PDF_UPSELL_HUSAP,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioHusap.PROPORTIONS_PDF_UPSELL_HUSAP]: {
    id: PageIdStylioHusap.PROPORTIONS_PDF_UPSELL_HUSAP,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
  [PageIdStylioHusap.DOWNLOAD_HUSAP]: {
    id: PageIdStylioHusap.DOWNLOAD_HUSAP,
    hasHeader: true,
    headerId: HeaderId.POLICY,
  },
}
